export const MEASUREMENT_META = {
  pm_ae_2_5: { label: 'PM2.5', unit: 'µg/m³' },
  pm_ae_1_0: { label: 'PM1.0', unit: 'µg/m³' },
  pm_ae_10_0: { label: 'PM10', unit: 'µg/m³' },
  co2: { label: 'CO₂', unit: 'ppm' },
  temp: { label: 'Temp', unit: '°C' },
  humidity: { label: 'Humidity', unit: '%' },
  co_ppm: { label: 'CO', unit: 'ppm' },
  nox: { label: 'NOx', unit: 'index' },
  merc_ppm: { label: 'Mercaptan', unit: 'ppm' },
  tvoc: { label: 'TVOC', unit: 'ppm' },
  hcho: { label: 'HCHO', unit: 'ppm' },
};

const PREFERENCE = ['pm_ae_2_5', 'co2'];

export function metaFor(field) {
  return MEASUREMENT_META[field] || { label: field, unit: '' };
}

export function availableMeasurements(readings) {
  const keys = new Set();
  (readings || []).forEach((r) => Object.keys(r).forEach((k) => { if (k !== 't') keys.add(k); }));
  return Array.from(keys).sort();
}

export function defaultMeasurement(fields) {
  if (!fields || fields.length === 0) return null;
  const pref = PREFERENCE.find((p) => fields.includes(p));
  return pref || fields[0];
}
